var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "66wk1n8f1a",
    d: "M0 0.267L10.448 0.267 10.448 10.8 0 10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8qvemgdzkc",
    d: "M0.139 0.267L10.587 0.267 10.587 10.8 0.139 10.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rwlvlyqzgb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#66wk1n8f1a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M10.448 5.534c0 2.908-2.339 5.266-5.224 5.266C2.339 10.8 0 8.442 0 5.534 0 2.624 2.34.267 5.224.267c2.885 0 5.224 2.358 5.224 5.267",
    mask: "url(#rwlvlyqzgb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 6.728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ak4760y53d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8qvemgdzkc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M10.587 5.534c0 2.908-2.34 5.266-5.225 5.266S.14 8.442.14 5.534c0-2.91 2.338-5.267 5.223-5.267 2.886 0 5.225 2.358 5.225 5.267",
    mask: "url(#ak4760y53d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M20.661 3.474V1.67h2.69c.457 0 .829-.374.829-.835 0-.462-.372-.836-.83-.836h-3.517c-.458 0-.83.374-.83.836v1.967h-8.598l-.372-.912h1.28c.456 0 .827-.373.827-.835 0-.46-.37-.835-.828-.835H7.97c-.458 0-.83.374-.83.835 0 .462.372.835.83.835h.271l.69 1.693-4.43 8.036c-.144.259-.14.574.01.83.148.255.42.412.714.412h6.273c.312.672.988 1.139 1.774 1.139 1.082 0 1.96-.884 1.96-1.976 0-.32-.078-.62-.21-.887l4.583-5.859 2.97 7.299c.131.324.44.52.767.52.104 0 .21-.02.314-.064.423-.175.625-.663.452-1.09l-3.447-8.47zM9.738 5.56l2.093 5.129c-.135.147-.248.317-.333.5H6.633l3.105-5.63zm3.982 4.543c-.115-.027-.234-.043-.357-.05l-2.276-5.58h7.037l-4.404 5.63z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.e6c27e2a3159db43b362efe23e613da0.svg";
export { ForwardRef as ReactComponent };